// extracted by mini-css-extract-plugin
export var chip = "_aq-0";
export var filterDropdown = "_aq-5";
export var filterItem = "_aq-6";
export var icon = "_aq-1";
export var removeButton = "_aq-3";
export var removeIcon = "_aq-4";
export var separator = "_aq-2";